import API from '@/pages/application/components/appDetail/tabs/API'

export const LIMITED_ERROR_COMBO_NOT_ENOUGH = `limited-error-${API}`
